export const SITE = {
  name: "Bestconduite78",
  city: "Chatou",
  phone: "06 66 69 80 49",
  phoneIntl: "33666698049",
  email: "contact@bestconduite78.fr",
  address: "137 rue du Général Leclerc, 78400 Chatou",
  hours: [
    { days: "Lundi — Samedi", time: "9h00 – 19h00" },
    { days: "Dimanche", time: "Fermé" },
  ],
  kalioUrl:
    "https://app.kalio-pi.fr/iframe/all-reviews/show/8b2c77d5ab199afbea18a7f5b72d835280acaac44f6d1eb22c",
  kalioLogo: "/logo-kalio.png",
  googleUrl: "https://share.google/1Kt0mwYAOUH41xlVR",
  idfLogo: "/logo-idf.png",
  socials: {
    instagram: "https://www.instagram.com/best_conduite",
    tiktok: "https://www.tiktok.com/@bestconduitechatou",
  },
};

export const IMAGES = {
  heroCar: "/voiture-bestconduite.webp",
  step1:
    "https://images.unsplash.com/photo-1630406144797-821be1f35d75?crop=entropy&cs=srgb&fm=jpg&q=80&w=900&auto=format&fit=crop",
  step2:
    "https://images.pexels.com/photos/6817037/pexels-photo-6817037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  step3:
    "https://images.unsplash.com/photo-1604447199408-9798f9f64f88?crop=entropy&cs=srgb&fm=jpg&q=80&w=900&auto=format&fit=crop",
  about:
    "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000&auto=format&fit=crop",
};

export const FORMULES_TABS = {
  classique: [
    {
      id: "classique-bm",
      transmission: "Boîte manuelle",
      price: "1 100 €",
      featured: true,
      features: [
        "Boîte manuelle",
        "20 heures de conduite",
        "Accès au code en ligne",
        "Accompagnement à l'examen",
      ],
    },
    {
      id: "classique-ba",
      transmission: "Boîte automatique",
      price: "845 €",
      featured: false,
      features: [
        "Boîte automatique",
        "13 heures de conduite",
        "Accès au code en ligne",
        "Accompagnement à l'examen",
      ],
    },
    {
      id: "classique-ba25",
      transmission: "Boîte automatique",
      price: "1 300 €",
      featured: false,
      features: [
        "Boîte automatique",
        "25 heures de conduite",
        "Accès au code en ligne",
        "Accompagnement à l'examen",
      ],
    },
  ],
  accelere: [
    {
      id: "accelere-bm",
      transmission: "Boîte manuelle",
      price: "1 550 €",
      featured: true,
      features: [
        "Boîte manuelle",
        "20 heures de conduite intensif",
        "Accès au code en ligne",
        "Accompagnement à l'examen",
      ],
    },
    {
      id: "accelere-ba",
      transmission: "Boîte automatique",
      price: "1 350 €",
      featured: false,
      features: [
        "Boîte automatique",
        "13 heures de conduite intensif",
        "Accès au code en ligne",
        "Accompagnement à l'examen",
      ],
    },
  ],
};

export const FORMULES_EXTRA = [
  {
    id: "aac",
    title: "Conduite accompagnée (AAC)",
    subtitle: "Conduite accompagnée – AAC",
    description:
      "Dès 15 ans, un apprentissage progressif pour maximiser les chances de réussite.",
    options: ["Boîte manuelle – 20h : 1 290 €", "Boîte automatique – 13h : 1 190 €"],
  },
  {
    id: "perfectionnement",
    title: "Perfectionnement Permis B — 10h",
    subtitle: null,
    description:
      "Pour reprendre confiance, corriger ses lacunes ou se préparer à un nouvel examen.",
    options: ["Boîte manuelle – 10h : 550 €", "Boîte automatique – 10h : 650 €"],
  },
];

export const FORMULES = [
  { id: "classique-bm", name: "Permis B Classique — Boîte manuelle (20h)", price: "1 100 €" },
  { id: "classique-ba", name: "Permis B Classique — Boîte automatique (13h)", price: "845 €" },
  { id: "classique-ba25", name: "Permis B Classique — Boîte automatique (25h)", price: "1 300 €" },
  { id: "accelere-bm", name: "Permis B Accéléré — Boîte manuelle (20h intensif)", price: "1 550 €" },
  { id: "accelere-ba", name: "Permis B Accéléré — Boîte automatique (13h intensif)", price: "1 350 €" },
  { id: "aac-bm", name: "Conduite accompagnée AAC — Boîte manuelle (20h)", price: "1 290 €" },
  { id: "aac-ba", name: "Conduite accompagnée AAC — Boîte automatique (13h)", price: "1 190 €" },
  { id: "perf-bm", name: "Perfectionnement — Boîte manuelle (10h)", price: "550 €" },
  { id: "perf-ba", name: "Perfectionnement — Boîte automatique (10h)", price: "650 €" },
];

export const COMPARAISON_CARDS = {
  ours: [
    "Méthode d'apprentissage structurée et efficace",
    "Moniteurs qualifiés, pédagogues et bienveillants",
    "Suivi personnalisé jusqu'à l'examen",
    "Accès au code en ligne 24h/24",
    "Formations éligibles CPF & certifiées Qualiopi",
  ],
  others: [
    "Méthode peu personnalisée",
    "Suivi irrégulier des élèves",
    "Peu ou pas d'accompagnement jusqu'à l'examen",
    "Code parfois en option ou limité",
    "Pas toujours éligible CPF / non certifié",
  ],
};

export const ETAPES = [
  {
    num: "01",
    title: "Évaluation de départ",
    text: "Rendez-vous dans notre agence de Chatou pour une évaluation de départ d'une heure avec un moniteur diplômé (55 €). Il définit avec vous un plan de formation sur mesure, adapté à votre niveau et à vos objectifs.",
    image: "step1",
    alt: "Moniteur d'auto-école évaluant un élève conducteur à Chatou (78)",
  },
  {
    num: "02",
    title: "Formation sur mesure",
    text: "Code en salle et en ligne, leçons de conduite réservables en ligne, moniteur référent dédié : vous progressez à votre rythme, sur les routes de Chatou, du Vésinet et des Yvelines que vous connaîtrez par cœur le jour J.",
    image: "step2",
    alt: "Leçon de conduite personnalisée avec moniteur à Chatou, Yvelines",
  },
  {
    num: "03",
    title: "Examen en confiance",
    text: "Quand vous êtes prêt, nous vous présentons à l'examen dans les meilleures conditions : conduite supervisée juste avant, parcours d'entraînement réels et accompagnement le jour de l'épreuve. Objectif : réussir du premier coup.",
    image: "step3",
    alt: "Élève conducteur heureux après la réussite de son permis à Chatou",
  },
];

export const FAQ = [
  {
    q: "Combien de temps faut-il pour obtenir le permis ?",
    a: "Cela dépend de votre rythme et de la formule choisie (classique ou accélérée).",
  },
  {
    q: "Comment réserver mes heures de conduite ?",
    a: "Les réservations se font en ligne, simplement, selon vos disponibilités.",
  },
  {
    q: "Proposez-vous la boîte automatique ?",
    a: "Oui, on propose la boîte automatique.",
  },
  {
    q: "L'examen est-il inclus dans la formule ?",
    a: "Un accompagnement à l'examen pratique est inclus dans nos formules.",
  },
  {
    q: "Puis-je payer en plusieurs fois ?",
    a: "Oui, nous proposons un paiement flexible selon la formule choisie.",
  },
  {
    q: "Puis-je commencer les leçons sans avoir encore le code ?",
    a: "Oui, il est possible de commencer la conduite tout en préparant le code en ligne, selon votre niveau et après évaluation.",
  },
];

export const NAV_LINKS = [
  { label: "Formules", href: "#formules" },
  { label: "Avis", href: "#comparatif" },
  { label: "À propos", href: "#apropos" },
  { label: "FAQ", href: "#faq" },
];

export const FOOTER_LINKS = [
  { label: "Nos formules", href: "#formules" },
  { label: "Avis élèves", href: "#comparatif" },
  { label: "La méthode", href: "#methode" },
  { label: "À propos", href: "#apropos" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const MARQUEE_ITEMS = [
  "Chatou",
  "Le Vésinet",
  "Croissy-sur-Seine",
  "Montesson",
  "Carrières-sur-Seine",
  "Rueil-Malmaison",
  "Nanterre",
  "Yvelines (78)",
];
